import React from "react";
import { css, cx, styled } from "../../../theme/styled";
import { Card } from "../../card/Card";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.JSX.Element | React.JSX.Element[];
}

const InputListComponent = ({
  children,
  ...props
}: Props): React.JSX.Element => {
  return (
    <div
      className={cx(
        Card.Variant.Plain,
        css({
          display: "flex",
          flexDirection: "column",
          padding: ["$spacing-8", "$spacing-16"],
        }),
      )}
      {...props}
    >
      {children}
    </div>
  );
};

const ListItemComponent = ({
  children,
  ...props
}: Props): React.JSX.Element => {
  return <ListItem {...props}>{children}</ListItem>;
};

const ListItem = styled.div({
  padding: ["$spacing-12", "$spacing-0"],
  borderBottom: "1px solid $border-subtle",

  "&:last-of-type": {
    borderBottom: 0,
  },
});

export const InputList = Object.assign(InputListComponent, {
  Item: ListItemComponent,
});
